import { render } from "./InterstitialSection.vue?vue&type=template&id=99fbf2e6"
import script from "./InterstitialSection.vue?vue&type=script&lang=js"
export * from "./InterstitialSection.vue?vue&type=script&lang=js"

import "./InterstitialSection.vue?vue&type=style&index=0&id=99fbf2e6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__